import '@formkit/themes/genesis';
import '@formkit/pro/genesis';
import {generateClasses} from '@formkit/themes';
import theme from './formkit.theme';
import {
  add,
  applicationIcons,
  arrowDown,
  arrowUp,
  check,
  circle,
  close,
  down,
  fileDoc,
  genesisIcons,
  spinner,
  star,
  trash,
} from '@formkit/icons';
import {DefaultConfigOptions} from '@formkit/vue';
import {createProPlugin, inputs} from '@formkit/pro';
import {FormKitNode} from '@formkit/core';
import {DateTime} from "luxon";

const pro = createProPlugin('fk-644908e468', inputs);
const legends = ['checkbox_multi', 'radio_multi', 'repeater', 'transferlist'];

/*const isCheckboxAndRadioMultiple = (node: FormKitNode) =>
  (node.props.type === 'checkbox' || node.props.type === 'radio') && node.props.options;*/

function addOptionalLabelPlugin(node: FormKitNode) {
  if (['button', 'submit', 'hidden', 'group', 'list', 'meta', 'form'].includes(node.props.type)) return;

  node.on('created', () => {
    const legendOrLabel = legends.includes(`${node.props.type}${node.props.options ? '_multi' : ''}`) ? 'legend' : 'label';

    if (node.props.definition?.schemaMemoKey) {
      node.props.definition.schemaMemoKey = `${node.name}-${Date.now()}-${Math.random()}`;
    }

    const schemaFn = node.props.definition?.schema;

    node.props.definition.schema = (sectionsSchema = {}) => {
      sectionsSchema[legendOrLabel] = {
        children: [
          {
            $el: 'span',
            attrs: {
              innerHTML: `${node.props.label || ''}`,
            },
          },
          {
            $el: 'span',
            if: '$state.required === false',
            attrs: {
              class: 'text-[20px] font-light text-gray-400 pl-2',
            },
            children: [node.name !== 'allowContact' ? `— Optional` : ''],
          },
        ],
      };

      return typeof schemaFn === 'function' ? schemaFn(sectionsSchema) : sectionsSchema;
    };
  });

  node.on('created', async () => {
    if (node.props.type === 'number') {
      setTimeout(() => {
        try {
          const element = document.getElementById(`${node.props.id}`);
          if (element !== null) {
            element.addEventListener('keydown', function (e) {
              if (e.key === 'e' || e.key === 'E') {
                e.preventDefault();
              }
            });
          }
        } catch (error) {
          console.error('Error adding event listener:', error);
        }
      }, 1000);
    }
  });

  node.hook.submit((payload, next) => {
    node?.children?.forEach((child: any) => {
      if (child.context?.type === 'mask' && child.context?.mask === '{#,##|repeat}#.##') {
        if (child.context?.value && typeof child.context.value === 'string' && child.context.value.length === 1) {
          try {
            const parsedValue = parseInt(child.context.value);
            if (!isNaN(parsedValue)) {
              payload[child.name] = `${parsedValue * 100}`;
            } else {
              console.warn(`Failed to parse value: ${child.context.value}`);
            }
          } catch (error) {
            console.error('Error parsing value:', error);
          }
        }
      }
    });
    return next(payload);
  });
}

const config: DefaultConfigOptions = {
  messages: {
    en: {
      validation: {
        required() {
          return `This field is required.`;
        },
        min({ args }) {
          return `Must be at least ${args[0]}.`;
        },
        max({ args }) {
          return `Must be at most ${args[0]}.`;
        },
        date_before({ args }) {
          const date = DateTime.fromFormat(args[0], 'yyyy-MM-dd')
          return `Must be before ${date.toFormat('MMM, d yyyy')}.`;
        },
        date_after({ args }) {
          const date = DateTime.fromFormat(args[0], 'yyyy-MM-dd')
          return `Must be on or after ${date.plus({days: 1}).toFormat('MMM, d yyyy')}.`;
        },
      },
    },
  },
  config: {
    classes: generateClasses(theme),
  },
  plugins: [pro, addOptionalLabelPlugin],
  icons: {
    ...applicationIcons,
    ...genesisIcons,
    close,
    down,
    fileDoc,
    check,
    circle,
    spinner,
    star,
    trash,
    add,
    arrowUp,
    arrowDown,
    checkboxDecorator: check,
  },
};
export default config;
